import { Button, FormControl, Flex, FormLabel, Input, Link, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';

import PageContainer from '../../components/pageContainer/PageContainer';
import { handleLogin } from '../../slice/appSlice';

function Login() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [disabled, setDisabled] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async(e) => {
    e.preventDefault();
    setDisabled(true);

    const res = (await dispatch(handleLogin({ email, password }))).payload;
    if (!res.ok) {
      setDisabled(false);
      
      // Check if account requires verification
      if (res.body?.requiresVerification) {
        // Redirect to signup page with verification step and email
        history.push({
          pathname: '/signup',
          state: { 
            isVerificationStep: true, 
            email: res.body.email 
          }
        });
      }
    }
  };
  return (
    <PageContainer>
      <Text color='#377DFF' fontSize='2xl' fontWeight={500}>Login</Text>
      <form onSubmit={handleSubmit} disabled={disabled}>
        <FormControl margin='10px 0' isRequired>
          <FormLabel>Email</FormLabel>
          <Input w='300px' value={email} onChange={e => setEmail(e.target.value)} placeholder='Email'/>
        </FormControl>
        <FormControl margin='10px 0' isRequired>
          <FormLabel>Password</FormLabel>
          <Input w='300px' value={password} type='password' onChange={e => setPassword(e.target.value)} placeholder='Password'/>
        </FormControl>
        <Button margin='10px 0' backgroundColor='#007bff' color='white' _hover={{ bg: '#0069d9', color: 'whitesmoke' }} type='submit'>Login</Button>
      </form>
      <Flex>
        <Text fontSize={12}>
          <Link as={NavLink} to='/reset-password'>Forgot Password?</Link>
        </Text>
      </Flex>
    </PageContainer>
  );
}

export default Login;
